var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.dialog,"z-index":"1000"}},[_c('v-card',{attrs:{"color":"primary","dark":"","width":"500"}},[_c('v-card-text',{staticClass:"ma-0"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n      "),_c('v-progress-linear',{staticClass:"mt-2 mb-1",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }